<div>

  <tabset #staticTabs>
    <tab heading="General Info" class="GeneralInfo">
      Transfer Your Assessed Value
    </tab>
    <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab>

  </tabset>
</div>
